import type { FieldValues, Message, Path, UseControllerProps } from 'react-hook-form';
import { OptionWithHint } from '#components/patterns/forms/select/option/OptionWithHint.tsx';
import { SelectAsyncControlled } from '#components/patterns/forms/select/select-async/SelectAsyncControlled.tsx';
import { SelectItem } from '#components/patterns/forms/select/select-item/SelectItem.tsx';
import type { DomainListItem } from '#dn-types/domain.ts';
import { makeSelectDomainQueryOptions } from './SelectDomain.queries.ts';

type Props<T extends FieldValues, N extends Path<T>> = {
  errorMessage?: Message;
  label: string;
  className?: string;
  filterDomains?: (domain: DomainListItem) => boolean;
} & UseControllerProps<T, N> &
  Omit<React.ComponentProps<typeof SelectAsyncControlled>, 'getItemsQueryOptions' | 'control' | 'renderOptions'>;

export function SelectDomain<T extends FieldValues, N extends Path<T>>({
  label,
  errorMessage,
  filterDomains,
  control,
  name,
  className,
  ...props
}: Props<T, N>) {
  return (
    <SelectAsyncControlled
      className={className}
      getItemsQueryOptions={makeSelectDomainQueryOptions(filterDomains)}
      control={control}
      name={name}
      label={label}
      placeholder="Please select…"
      errorMessage={errorMessage}
      renderOptions={({ onChange, items }) => (
        <>
          {items.map((itm) => (
            <SelectItem key={itm.value} value={itm.value} onClick={() => onChange(itm.value)}>
              {itm.hint ?
                <OptionWithHint value={itm.label} hint={itm.hint} />
              : itm.label}
            </SelectItem>
          ))}
        </>
      )}
      {...props}
    />
  );
}
